import React from 'react' 
import styled from 'styled-components'
import { IntroText, StyledTitle , Container} from './styled'


const AboutMe = props => {

    return (
        <Container className="section container has-text-centered" id="about">
            <StyledTitle>1. About me</StyledTitle>

            <Content className="content">
                <div className="columns is-desktop">
                    <div className="column">
                        <figure className="image">
                            <Img src="/shad.jpeg" alt="Main display" />
                        </figure>
                    </div>
                    <div className="column">
                        <IntroText className="has-text-left">
                            <p className="mb-1">
                                Hi, my name is Shadrack Mwangi. I am a fullstack software developer.
                            </p>
                            <p className="mt-2">
                                I am fuelled by the passion to understand the nuances of technical tools. I consider myself a 
                                'life-long student', eager to build on my academic foundation in computer science and stay 
                                in tune with the latest software development tools through continued coursework and professional
                                development.
                            </p>

                            <p className="mt-2">
                                An alumnus of <InLink href="https://meltwater.org/">Mest Africa</InLink>. After completing a course 
                                in software entrepreneurship, I refocused on developing my software skills and joined a team of 
                                world class engineers at <InLink href="#">Inable Org</InLink> where we worked on an AI tool to enable 
                                visually impaired students take exams online. After that I have been a freelance developer and have worked 
                                on a wide range of both web and system applications.
                            </p>
                            
                        </IntroText>
                    </div>
                </div>
            </Content>
        </Container>
    )
}

const InLink = styled.a `
    color:  #da6c36;
`



const Content = styled.div `
    margin-top: 2rem;
`

const Img = styled.img `
    width: 25rem;
    border-radius: 30px;
`

export default AboutMe